import CommonHeader from '../Components/Headers/CommonHeader';
import Enrichment from '../modules/enrichment/Enrichment';

export default function EnrichmentPage() {
  return (
    <>
      <CommonHeader />
      <Enrichment />
    </>
  );
}
